<div mat-dialog-title>
    <h2
        #dialogTitle
        tabindex="-1"
        appLocalizationPopupDirective
        [localizationCode]="'BuySellRequest'">
        {{ 'BuySellRequest' | translate: {Default: "Buy/Sell Request"} }}
    </h2>

    <mat-chip-set
        *ngIf="buySellPlanEmployee"
        [attr.aria-label]="'ApprovalStatus' | translate: {Default: 'Approval Status'}">
        <mat-chip
            [ngClass]="getStatusChipClass()"
            [attr.aria-label]="('ApprovalStatus' | translate: {Default: 'Approval Status'}) + ': ' + buySellPlanEmployee?.status?.name">
            {{ buySellPlanEmployee?.status?.name }}
        </mat-chip>
    </mat-chip-set>
</div>


<mat-dialog-content>
    <ng-container *ngIf="isAnyLoading; else loaded">
        <ngx-skeleton-loader
            count="5"
            [theme]="{ 'height.px': 50 }"
        ></ngx-skeleton-loader>
    </ng-container>

    <ng-template #loaded>
        <div class="content-layout">
            <!-- Left Panel -->
            <div class="left-panel">
                <app-employee-contact-card 
                    *ngIf="employeeId" 
                    [employeeId]="employeeId">
                </app-employee-contact-card>

                <app-buy-sell-plan-details 
                    *ngIf="buySellPlan" 
                    [buySellPlan]="buySellPlan">
                </app-buy-sell-plan-details>
            </div>

            <!-- Right Panel -->
            <div class="right-panel">
                <ng-container [ngSwitch]="getDisplayMode()">
                    <!-- No Request Submitted Yet -->
                    <div *ngSwitchCase="'no-request'" class="no-request-message">
                        <p class="no-data" appLocalizationPopupDirective localizationCode="NoBuySellRequest">
                            {{ 'NoBuySellRequest' | translate: {Default: "No Buy/Sell request has been submitted for this plan."} }}
                        </p>
                    </div>

                    <!-- Tabs Content -->
                    <mat-tab-group 
                        *ngSwitchDefault 
                        class="buy-sell-request-tabs" 
                        mat-stretch-tabs
                        setColor="primaryColour"
                        (selectedTabChange)="onTabChange($event)">
                        
                        <!-- Request Tab -->
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <span appLocalizationPopupDirective localizationCode="BuySellRequestTab1">
                                    {{ 'BuySellRequestTab1' | translate: {Default: "Request"} }}
                                </span>
                            </ng-template>

                            <div #requestTabContent tabindex="-1" class="tab-content-padding">
                                <ng-container [ngSwitch]="getRequestTabMode()">
                                    <!-- Employee Request Form -->
                                    <app-buy-sell-request-form
                                        *ngSwitchCase="'form'"
                                        [buySellPlanEmployee]="buySellPlanEmployee"
                                        [employeeTimeOffType]="employeeTimeOffType"
                                        [compensation]="compensation"
                                        [buySellPlan]="buySellPlan"
                                        (requestSubmitted)="submit()"
                                        [selectedType]="selectedType"
                                        (selectedTypeChange)="selectedType = $event"
                                        [hoursInput]="hoursInput"
                                        (hoursInputChange)="hoursInput = $event"
                                    >
                                    </app-buy-sell-request-form>

                                    <app-buy-sell-approval-form
                                        *ngSwitchCase="'approval-form'"
                                        [buySellPlanEmployee]="buySellPlanEmployee"
                                        [compensation]="compensation"
                                        [buySellApproval]="getCorrectApproval()"
                                        [buySellPlan]="buySellPlan"
                                        [selectedType]="selectedType"
                                        (approvalUpdated)="getBuySellPlanEmployee()">
                                    </app-buy-sell-approval-form>

                                    <!-- Status Display for Non-Employee -->
                                    <app-approval-status-card
                                        *ngSwitchCase="'status-only'"
                                        [buySellPlanEmployee]="buySellPlanEmployee">
                                    </app-approval-status-card>

                                    <!-- Approval Summary -->
                                    <app-buy-sell-approval-summary
                                        *ngSwitchCase="'approval-summary'"
                                        [buySellPlanEmployee]="buySellPlanEmployee"
                                        [compensation]="compensation"
                                        [selectedType]="selectedType"
                                    >
                                    </app-buy-sell-approval-summary>
                                </ng-container>

                                <!-- Time Off Balance Calculations -->
                                <app-time-off-balance-calculations
                                    *ngIf="shouldShowCalculations()"
                                    [employeeTimeOffType]="employeeTimeOffType"
                                    [selectedType]="selectedType"
                                    [hoursInput]="hoursInput"
                                    [buySellPlanEmployee]="buySellPlanEmployee"
                                    [compensation]="compensation">
                                </app-time-off-balance-calculations>
                            </div>
                        </mat-tab>

                        <!-- Reviewers Tab -->
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <span appLocalizationPopupDirective localizationCode="BuySellRequestTab2">
                                    {{ 'BuySellRequestTab2' | translate: {Default: "Reviewers"} }}
                                </span>
                            </ng-template>
                            <div #reviewersTabContent tabindex="-1" class="tab-content-padding">
                                <app-buy-sell-reviewers-list    
                                    [buySellPlanApprovals]="buySellPlanApprovals"
                                ></app-buy-sell-reviewers-list>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </ng-container>
            </div>
        </div>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button
        type="button"
        mat-stroked-button
        class="close"
        [attr.aria-label]="'Close' | translate: {Default: 'Close'}"
        appPreventDoubleClick
        (throttledClick)="close()">
        {{ 'Close' | translate: {Default: "Close"} }}
    </button>
</mat-dialog-actions>
